import { render, staticRenderFns } from "./BuildDataset.vue?vue&type=template&id=1f3cb5c6&scoped=true"
import script from "./BuildDataset.vue?vue&type=script&lang=js"
export * from "./BuildDataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3cb5c6",
  null
  
)

export default component.exports